import type { Partner } from "@expert/shared-types";

import { getAppConfigSingleton } from "@expert/app-config";

export function getPartnerTool(partner: Partner) {
    const appConfig = getAppConfigSingleton();
    const partnerTool = appConfig.getPartnersConfig(partner).partnerTool;

    if (partnerTool) {
        return partnerTool;
    } else {
        console.log(`No partner tool found for this partner: ${partner}`);
        return "partner tool";
    }
}
